/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Plan_DefaultInputs */

const en_model_plan_default = /** @type {(inputs: Model_Plan_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use my default`)
};

const id_model_plan_default = /** @type {(inputs: Model_Plan_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai default saya`)
};

/**
* | output |
* | --- |
* | "Use my default" |
*
* @param {Model_Plan_DefaultInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_plan_default = /** @type {((inputs?: Model_Plan_DefaultInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Plan_DefaultInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_plan_default(inputs)
	return en_model_plan_default(inputs)
});